import { Box, Divider } from '@factorialco/deprecated-design-system'

import { premiumOfferCardStyle } from './index.vanilla.css'

interface Props {
  heading: React.ReactNode
  body: React.ReactNode
  footer: React.ReactNode
}

export const PremiumOfferCard = ({ heading, body, footer }: Props) => {
  return (
    <Box
      className={premiumOfferCardStyle}
      gap="s8"
      borderRadius={{
        all: 'abs016',
      }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      paddingY="s12"
    >
      <Box paddingX="s16">{heading}</Box>
      <Box gap="s12">
        <Box gap="s4" paddingX="s16">
          {body}
        </Box>
        <Divider />
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          paddingX="s16"
          minHeight="s32"
        >
          {footer}
        </Box>
      </Box>
    </Box>
  )
}
